package com.arena_web.data.dto

import kotlinx.serialization.Serializable

/**
 * Single discoverable person from the People feed. Mirrors backend
 * `PersonDto` — all the data the card stack + detail popup need without a
 * second roundtrip per person.
 */
@Serializable
data class PersonDto(
    val userId: String,
    val username: String,
    val fullName: String,
    val age: Int,
    val city: String,
    val country: String? = null,
    val dateOfBirth: String,
    val bio: String? = null,
    val languages: List<String> = emptyList(),
    val interestSports: List<String> = emptyList(),
    val interestActivities: List<String> = emptyList(),
    val interestLifestyle: List<String> = emptyList(),
    /** Per-interest notes keyed by interest id. Drives the blue-dot marker on
     *  the interest chip in `PersonDetailDialog`. */
    val interestNotes: Map<String, String> = emptyMap(),
    val avatarUrl: String,
    val cardImageUrl: String? = null,
    val cardAssetsBasePath: String? = null,
    val cardTextColor: String? = null,
    val cardTemplateName: String? = null,
    val followingCount: Long = 0,
    val followersCount: Long = 0,
)

@Serializable
data class PeopleFeedDto(
    val people: List<PersonDto>,
    val hasMore: Boolean,
)

@Serializable
data class PeopleInteractionsDto(
    val newLikes: List<PersonDto> = emptyList(),
    val matches: List<PersonDto> = emptyList(),
)

/** Cheap count-only payload used by the header heart badge. */
@Serializable
data class PeopleInteractionsCountDto(
    val newLikes: Int = 0,
    val matches: Int = 0,
)

@Serializable
data class SwipeRequest(
    /** "LIKE" or "SKIP". */
    val action: String,
)

@Serializable
data class SwipeResponse(
    val swipeId: String,
    val targetUserId: String,
    val action: String,
)
